import FadeInOut from "../../FadeInOut";

import { useAutoLayoutContext } from "../../../contexts/AutoLayoutProvider";

import "./DragHandle.scss";

const DragHandle = () => {
  const { autoLayoutOn } = useAutoLayoutContext();

  return (
    <FadeInOut show={!autoLayoutOn} duration={250}>
      <div className="drag-handle" />
    </FadeInOut>
  );
};
export default DragHandle;
